module.exports = __webpack_public_path__ + "img/smartz-events-slide1.61fdde94.png";